/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { IAaiVisitor } from '../visitors/IAaiVisitor';
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { IReferenceNode } from '../../core/models/IReferenceNode';
import { Node } from '../../core/models/Node';
import { INamed } from '../../core/models/common/INamed';
import { Parameter } from '../../core/models/common/Parameter';
import { Schema } from '../../core/models/common/Schema';
import { IVisitor } from '../../core/visitors/IVisitor';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends ExtensibleNode
 * @author Jakub Senko <jsenko@redhat.com>
 */
export abstract class AaiParameter extends ExtensibleNode implements IReferenceNode, INamed {
    public _name : string;

    public $ref : string;

    public description : string;

    public schema : any;

    public location : string;

    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            {
                let __args = arguments;
                super();
                if(this._name===undefined) this._name = null;
                if(this.$ref===undefined) this.$ref = null;
                if(this.description===undefined) this.description = null;
                if(this.schema===undefined) this.schema = null;
                if(this.location===undefined) this.location = null;
                if(this._name===undefined) this._name = null;
                if(this.$ref===undefined) this.$ref = null;
                if(this.description===undefined) this.description = null;
                if(this.schema===undefined) this.schema = null;
                if(this.location===undefined) this.location = null;
                (() => {
                    if(parent != null) {
                        this._parent = parent;
                        this._ownerDocument = parent.ownerDocument();
                    }
                })();
            }
            (() => {
                this._name = name;
            })();
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super();
            if(this._name===undefined) this._name = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.description===undefined) this.description = null;
            if(this.schema===undefined) this.schema = null;
            if(this.location===undefined) this.location = null;
            if(this._name===undefined) this._name = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.description===undefined) this.description = null;
            if(this.schema===undefined) this.schema = null;
            if(this.location===undefined) this.location = null;
            (() => {
                this._name = name;
            })();
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            super();
            if(this._name===undefined) this._name = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.description===undefined) this.description = null;
            if(this.schema===undefined) this.schema = null;
            if(this.location===undefined) this.location = null;
            if(this._name===undefined) this._name = null;
            if(this.$ref===undefined) this.$ref = null;
            if(this.description===undefined) this.description = null;
            if(this.schema===undefined) this.schema = null;
            if(this.location===undefined) this.location = null;
            (() => {
                if(parent != null) {
                    this._parent = parent;
                    this._ownerDocument = parent.ownerDocument();
                }
            })();
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        (<IAaiVisitor><any>visitor).visitAaiParameter(this);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#getName()
     * @return {string}
     */
    public getName() : string {
        return this._name;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.INamed#rename(java.lang.String)
     * @param {string} newName
     */
    public rename(newName : string) {
        this._name = newName;
    }

    /**
     * 
     * @return {string}
     */
    public getReference() : string {
        return this.$ref;
    }

    /**
     * 
     * @param {string} reference
     */
    public setReference(reference : string) {
        this.$ref = reference;
    }
}
AaiParameter["__class"] = "io.apicurio.datamodels.asyncapi.models.AaiParameter";
AaiParameter["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




